import { GroupMember } from '@front-app/services/UserApi/UserModel';
import { sortAlphabeticalDesc, sortDateDesc } from '@front-app/util/sort';

export function sortGroupMemberByName(a: GroupMember, b: GroupMember): number {
	const result = sortAlphabeticalDesc(`${a.firstName}${a.middleName}${a.lastName}`.trim(), `${b.firstName}${b.middleName}${b.lastName}`.trim());
	if (result === 0) {
		return sortAlphabeticalDesc(a.id, b.id);
	}
	return result;
}

export function sortGroupMemberByJoinDate(a: GroupMember, b: GroupMember): number {
	const result = sortDateDesc(a.groupJoinDate, b.groupJoinDate);
	if (result === 0) {
		return sortAlphabeticalDesc(a.id, b.id);
	}
	return result;
}
